import { BaseRecord } from 'types';
import { InvoiceItem } from './InvoiceItem';
import { SaleOrder } from './SaleOrder';

export enum InvoiceStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  ISSUED = 'ISSUED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}
export enum InvoiceType {
  ALL_INCLUDE_DRAFT = -1, // Tất cả (bao gồm nháp)
  ALL_EXCLUDE_DRAFT = 0, // Tất cả (không lấy nháp)
  DRAFT = 1, // Nháp
  NEW = 2, // Hóa đơn mới
  CANCELLED = 3, // Hóa đơn xóa bỏ
  REPLACEMENT = 4, // Hóa đơn thay thế
  REPLACED = 5, // Hóa đơn bị thay thế
  ADJUST_INCREASE = 6, // Hóa đơn điều chỉnh tăng
  ADJUST_DECREASE = 7, // Hóa đơn điều chỉnh giảm
  ADJUST_INFO = 8, // Điều chỉnh thông tin
  ADJUST_BOTH = 9, // Điều chỉnh tăng/giảm
  ADJUSTED = 10, // Hóa đơn bị điều chỉnh
}

export interface Invoice {
  id: string;
  saleOrderId: string;
  saleOrder: SaleOrder;
  providerInvoiceId?: string;
  invoiceNo?: string;
  invoiceSeries?: string;
  lookupCode?: string;
  referenceCode?: string;
  status: InvoiceStatus | null;
  statusType?: number;
  statusText?: string;
  invoiceType?: number;
  invoiceTypeText?: string;
  invoiceCategory?: number;
  invoiceCategoryText?: string;
  totalBeforeTax: string;
  taxAmount: string;
  totalAfterTax: string;
  buyerInfo: string;
  buyerName?: string;
  buyerEmail?: string;
  buyerAddress?: string;
  buyerCompanyName?: string;
  buyerCitizenId?: string;
  buyerPhoneNumber?: string;
  buyerTaxCode?: string;
  paymentMethod?: string;
  items: InvoiceItem[];
  filePath?: string;
  signedAt?: Date | string;
}
export interface InvoiceRecord extends BaseRecord<SaleOrder | InvoiceItem> {
  id: string;
  saleOrderId: string;
  saleOrder: SaleOrder;
  providerInvoiceId?: string;
  invoiceNo?: string;
  invoiceSeries?: string;
  lookupCode?: string;
  referenceCode?: string;
  status: InvoiceStatus | null;
  statusType?: number;
  statusText?: string;
  invoiceType?: number;
  invoiceTypeText?: string;
  invoiceCategory?: number;
  invoiceCategoryText?: string;
  totalBeforeTax: string;
  taxAmount: string;
  totalAfterTax: string;
  buyerInfo: string;
  buyerName?: string;
  buyerEmail?: string;
  buyerAddress?: string;
  buyerCompanyName?: string;
  buyerCitizenId?: string;
  buyerPhoneNumber?: string;
  buyerTaxCode?: string;
  paymentMethod?: string;
  items: InvoiceItem[];
  invoiceItems?: InvoiceItem[];
  filePath?: string;
  createdAt: Date;
}
export interface EInvoice extends Invoice {
  createdAt: Date;
}
export interface TemplateEInvoice {
  thDon: string;
  khmshDon: string;
  khhDon: string;
  sLuong: number;
  cLai: number;
}
